<template>
   	<div class="bg">
   		<div class="rankTitle" id="rankTitle">
   			<i @click="back"><img src="../assets/images/goback_1.png"/></i>
   			<h2>{{rankList[rankPageIndex].rankName}}</h2>
   		</div>
   		<div class="rankHead" :style="{'background-image':'url('+rankImgUrl+')'}">
   			<p class="rankTime">{{rankTime}}</p>
   		</div>
   		<v-rankSonglist></v-rankSonglist>
   	</div>
</template>

<script>
import rankSongList from '../components/rankSongList.vue'
import { mapGetters } from 'vuex'
  export default {
    data () {
      return {
      
      }
    },
    computed: {
    	...mapGetters(['rankTime','rankList','rankImgUrl','rankPageIndex'])
    },
    mounted: function(){
    	//this.$store.commit('navShow', false);
    	$(window).scrollTop=0;
    	$(window).scroll(function(){
    		var wh=$(window).scrollTop();
	    	var th=$('.rankTitle').scrollTop();
	    	if(wh>140){
	    		$('#rankTitle').addClass('rankTitle2');
	    	}else{
	    		$('#rankTitle').removeClass('rankTitle2');
	    	}
    	});
    },
    components:{
	  'v-rankSonglist':rankSongList,
  	},
    methods: {
      back(){
      	this.$router.go(-1);
      	this.$store.commit('setIscurrent', -1);
      	//this.$store.commit('navShow', true);
      }
    }
  }
</script>

<style>
.nav{z-index: 9;}
.bg{width: 100%;height: 100%;overflow: hidden;background: url(../assets/images/bg01.jpg);background-size:15%; }
.songList{width: 100%;position: absolute;top:40%;color: #fff;z-index: 11;}
.songNum{position: absolute;top:18%;width: 100%;height: 34px;background: #000;color: #ccc;padding-left: 28px;line-height: 34px;font-size: 14px;}

.rankTitle{width: 100%;height: 42px;position: fixed;top:70px;z-index: 12; background: -webkit-linear-gradient(top,rgba(0,0,0,.5),transparent);transition: all 0.5s;}
.rankTitle i{position: absolute;left:0px;top:0px;width: 40px;height: 40px;padding: 6px 0 0 10px;box-sizing: border-box;}
.rankTitle i img{width: 14px;}
.rankTitle h2{text-align: center;font-size: 18px;color: #fff;line-height: 34px;}
.rankTitle2{background: #000;transition: all 0.5s;}
.rankHead{width: 100%;height: 30%;position: absolute;z-index: 10;top:70px;background-size: 100%;background-position: center;position: relative;background-color: #242424;}
.rankTime{padding:10px 0 15px 20px;box-sizing:border-box; width:100%;height:45px;position: absolute;bottom:0;left:0;font-size: 15px;color: #fff;background: -webkit-linear-gradient(bottom,rgba(0,0,0,.5),transparent);}
</style>


// WEBPACK FOOTER //
// rankPage.vue?10a8d8a0